import "./aboutus.scss"

export default function AboutSidebar(props) {
    return (
        <div className="about-sidebar">
            <h2 className="h2">{props.title}</h2>
            <h3 className="h6">{props.subTitle}</h3>
        </div>
    )
} 